export default function isVisibleMaker(maker, state) {
  // If is_active is missing, assume visible
  const isActive =
    typeof maker.is_active !== "undefined" ? maker.is_active : true

  // If email is missing, assume visible
  const email = typeof maker.email !== "undefined" ? maker.email : ""

  const notTestMaker =
    !state.isProduction || !state.testMakers.includes(maker.id)
  const emailCheck = !state.isProduction || !email.includes("anddine")

  return isActive && notTestMaker && emailCheck
}
